module.exports = __webpack_public_path__ + "186357ed30cd21281d79fd258c6edab7.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons.svg
// module id = 142
// module chunks = 0